import { render } from "./arrroval.vue?vue&type=template&id=455e7148&scoped=true"
import script from "./arrroval.vue?vue&type=script&lang=js"
export * from "./arrroval.vue?vue&type=script&lang=js"

import "./arrroval.vue?vue&type=style&index=0&id=455e7148&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455e7148"]])

export default __exports__